@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div [formGroup]="SettingForm" class="one" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <h1 fxFlex="100" class="pr-1"><strong>Matter Class Rates</strong></h1> -->
  </div>
  <div fxLayout="row" class="mb-10" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <p fxFlex="100" class="pr-1 text-[14px]! font-semibold!">
      You only need to enter entries here if the rates are different for a selected matter class
      from the fee earners defaults values.
    </p>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mb-4">
    <mat-form-field class="matter-input pr-1" appearance="outline">
      <mat-label>Matter Class</mat-label>
      <mat-select (selectionChange)="CurrencyClassChange($event.value)">
        @for (item of Classdata; track item) {
          <mat-option [value]="item">{{ item.LOOKUPFULLVALUE }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="w-full">
    <div fxFlex="100">
      <mat-accordion class="faqs-accordion">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="flex w-full">
                <div class="flex w-20 grow items-center gap-10">
                  <mat-icon>
                    <!-- <img src="assets/icons/web_app/icon_contact_d.ico"  > -->
                    @if (currentUser?.THEMECOLOUR == 'theme-default') {
                      <img src="assets/icons/web_app/Contact Base Icon 1.svg" />
                    }
                    @if (currentUser?.THEMECOLOUR == 'theme-yellow-light') {
                      <img src="assets/icons/web_app/Contact Base Icon 1.svg" />
                    }
                    @if (currentUser?.THEMECOLOUR == 'theme-blue-gray-dark') {
                      <img src="assets/icons/web_app/Contact Base Icon 2.svg" />
                    }
                    @if (currentUser?.THEMECOLOUR == 'theme-pink-dark') {
                      <img src="assets/icons/web_app/Contact Base Icon 2.svg" />
                    }
                  </mat-icon>
                  <strong>Fee Earner Rates</strong>
                </div>
                <div class="shrink-0">
                  <button
                    matButton="filled"
                    class="mat-accent"
                    (click)="AddNewRate('new', '1', '')"
                  >
                    New Fee Earner Rate
                  </button>
                </div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <table class="w-full">
              @if (UserRateData.length == 0) {
                <tr>
                  <td colspan="2" style="text-align: center; font-weight: bold">Data not found</td>
                </tr>
              }
              @for (item of UserRateData; track item) {
                <tr>
                  <td class="text-[14px]">
                    {{ item.USERID }}&nbsp;&nbsp;{{ item.RATEPERHOUR }}Ex/Hr &nbsp;&nbsp;{{
                      item.RATEPERDAY
                    }}
                    Ex/Day
                  </td>
                  <td class="w-25">
                    <mat-icon
                      style="cursor: pointer"
                      class="pr-1"
                      (click)="AddNewRate('edit', '1', item.USERRATEGUID)"
                    >
                      edit
                    </mat-icon>
                    <mat-icon style="cursor: pointer" class="pr-1" (click)="DeleteRate(item)">
                      delete
                    </mat-icon>
                  </td>
                </tr>
              }
            </table>
          </div>
        </mat-expansion-panel>
        <!-- <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title fxLayout="row" fxLayoutAlign="start center">
            <div fxFlex="80">
              <mat-icon>
                <img src="assets/icons/web_app/icon_time_cost_d.ico"  >
              </mat-icon>
              &nbsp;&nbsp;
              <strong>Activity Rates</strong>
            </div>
            <div fxFlex="30">
              <button mat-raised-button color="accent" (click)="AddNewRate('new','2','')">New Activity Rate</button>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          Activity Rates body
        </div>
      </mat-expansion-panel> -->
        <!-- <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title fxLayout="row" fxLayoutAlign="start center">
          <div fxFlex="80">
            <mat-icon>
              <img src="assets/icons/web_app/icon_expenses_d.ico"  >
            </mat-icon>&nbsp;&nbsp;
            <strong>Sundry Rates</strong>
          </div>
          <div fxFlex="30">
            <button mat-raised-button color="accent" (click)="AddNewRate('new','2','')">New Sundry Rate</button>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div>
        Sundry Rates body
      </div>
    </mat-expansion-panel> -->
      </mat-accordion>
    </div>
  </div>
</div>
